import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import NavButton from '../wp-adons/TransitionLink'
import * as Scroll from 'react-scroll'
export default function Link ({ url, children, ...props }) {
  const hasAnchor = url => url?.includes('#')
  const scroller = Scroll.scroller
  const navigate = useNavigate()
  const sliptAnchorAndPath = url => ({
    path: url.split('#')[0],
    anchor: url.split('#')[1]
  })
  const scroll = async anchor => {
    await scroller.scrollTo(anchor, {
      duration: 2000,
      delay: 0,
      smooth: true,
      offset: 30
    })
  }
  const goToHomeAndScroll = async url => {
    const { anchor } = sliptAnchorAndPath(url)
    await navigate(url)
    await scroll(anchor)
  }
  return hasAnchor(url) ? (
    <NavButton
      className='cursor-pointer'
      {...props}
      onClick={() => goToHomeAndScroll(url)}
    >
      {children}
    </NavButton>
  ) : (
    <NavLink to={`${url}`} {...props}>
      {children}
    </NavLink>
  )
}
